import { chakra } from "@chakra-ui/react";
import React from "react";

import getCurrencyValue from "lib/getCurrencyValue";
import { Skeleton } from "toolkit/chakra/skeleton";

interface Props {
  value: string | null;
  currency?: string;
  exchangeRate?: string | null;
  className?: string;
  accuracy?: number;
  accuracyUsd?: number;
  decimals?: string | null;
  isLoading?: boolean;
  startElement?: React.ReactNode;
}

const CurrencyValue = ({
  value,
  currency = "",
  decimals,
  exchangeRate,
  className,
  accuracy,
  accuracyUsd,
  isLoading,
  startElement,
}: Props) => {
  if (isLoading) {
    return (
      <Skeleton className={className} loading display="inline-block">
        0.00 ($0.00)
      </Skeleton>
    );
  }

  if (value === undefined || value === null) {
    return <chakra.span className={className}>-</chakra.span>;
  }
  const { valueStr: valueResult, usd: usdResult } = getCurrencyValue({
    value,
    accuracy,
    accuracyUsd,
    exchangeRate,
    decimals,
  });
  const usdFormatted = usdResult;

  return (
    <chakra.span
      className={className}
      display="inline-flex"
      rowGap={3}
      columnGap={1}
    >
      {startElement}
      <chakra.span display="inline-block">
        {valueResult}
        {currency ? ` ${currency}` : ""}
      </chakra.span>
      {usdFormatted && (
        <chakra.span color="text.secondary" fontWeight={400}>
          (${usdFormatted})
        </chakra.span>
      )}
    </chakra.span>
  );
};

export default React.memo(chakra(CurrencyValue));
